//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryQtLqjgTerm,
  queryQtLqjgTitle,
  queryTenantName,
} from '@/https/crEnroll'
import {
  queryTenantBjdz,
  queryTenantLogo,
} from '@/https/common'
import { Input } from '@/constant/componentConfig'
import {
  Code,
  MaxLength,
} from '@/utils/validatorClass'
import { cloneDeep } from '@/utils/lodash'
import TResultDrawer from './TResultDrawer'

export default {
  components: { TResultDrawer },

  data () {
    return {
      formData: {},
      config: [],
      bjImg: '',
      logoImg: '',
      tenantName: '',
      title: '',
      identifyCode: '',
      chooseTab: '',
      tableList: [],
      resultDrawerConfig: {
        show: false,
        options: {},
      },
    }
  },

  computed: {
    renderData () {
      return [
        new Input({
          label: '考生号',
          value: 'ksh',
          none: this.filterConfig('ksh'),
          required: true,
          rules: [
            new Code('考生号'),
            new MaxLength('考生号', 30),
          ],
          placeholder: '请输入考生号',
        }),
        new Input({
          label: '证件号码',
          value: 'zjhm',
          none: this.filterConfig('zjhm'),
          required: true,
          rules: [new MaxLength('证件号码', 20)],
          placeholder: '请输入证件号码',
        }),
        new Input({
          label: '姓名',
          value: 'xm',
          required: true,
          none: this.filterConfig('xm'),
          rules: [new MaxLength('姓名', 20)],
          placeholder: '请输入姓名',
        }),
        new Input({
          label: '验证码',
          value: 'yzm',
          required: true,
          placeholder: '请输入验证码',
          rules: [
            {
              validator: (rule, value, callback) => {
                if (value && value !== this.identifyCode) {
                  callback(new Error('验证码填写错误'))
                } else {
                  callback()
                }
              },
            },
          ],
        }),
      ]
    },
  },

  async created () {
    const res = await queryTenantBjdz()
    this.bjImg = res?.data || ''
    const logoRes = await queryTenantLogo()
    this.logoImg = logoRes?.data || ''
  },

  mounted () {
    this.identifyCode = ''

    this.setConfig()
    this.refreshCode()
    this.setTitle()
  },

  methods: {

    async setConfig () {
      const { data } = await queryQtLqjgTerm()
      this.config = data || []
    },

    filterConfig (key) {
      return !this.config.filter((el) => el.key === key)[0]?.isCheck
    },

    async setTitle () {
      const { data } = await queryQtLqjgTitle()
      this.title = data || ''
      const res = await queryTenantName()
      this.tenantName = res?.data || ''
    },

    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },

    async doQuery () {
      if (!await this.$refs.form.validate()) {
        return
      }

      this.resultDrawerConfig = {
        show: true,
        options: {
          ...cloneDeep(this.formData),
          title: this.title,
          tenantName: this.tenantName,
          bjImg: this.bjImg,
          logoImg: this.logoImg,
        },
      }

      this.doReset()
    },

    doReset () {
      this.formData = {}
    },

    refreshCode () {
      this.identifyCode = ''

      this.$refs.ident.refreshCode()
    },

  },
}
